import { render, staticRenderFns } from "./Mistake.vue?vue&type=template&id=6cd578bd&scoped=true&"
import script from "./Mistake.vue?vue&type=script&lang=js&"
export * from "./Mistake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd578bd",
  null
  
)

export default component.exports